import {isEmpty} from "@pg-mono/nodash";

import {SearchFormValuesType} from "../../../search/types/SearchFormValuesType";
import {IOfferListOffer} from "../../types/IOfferListOffer";
import {IOfferListLatestQuery} from "../types/IOfferListLatestQuery";
import {hasPriceFilter} from "../utils/has_price_filter";
import {useFetchAdditionalOfferList} from "./use_fetch_additional_offers_list";

interface IProps {
    offersOnPage: IOfferListOffer[];
    allOffers: IOfferListOffer[];
    latestQuery: IOfferListLatestQuery;
    searchFormValues: SearchFormValuesType;
    privilegedOffers: IOfferListOffer[];
    isLastPage: boolean;
}

export const useGetOfferListingAllOffers = (props: IProps) => {
    const {offersOnPage, allOffers, privilegedOffers, isLastPage, latestQuery, searchFormValues} = props;
    const offersWithoutPriceFilter = useFetchAdditionalOfferList({latestQuery, isLastPage});

    if (hasPriceFilter(searchFormValues)) {
        const mainOffersWithPrice = offersOnPage.filter((offer) => offer.has_required_prices === true);
        const mainOffersWithPriceCount = allOffers.filter((offer) => offer.has_required_prices === true).length;
        const privilegedOfferIds = privilegedOffers.map(({id}) => id);
        const mainOffers = [
            ...privilegedOffers,
            ...(isEmpty(privilegedOffers) ? mainOffersWithPrice : mainOffersWithPrice.filter(({id}) => !privilegedOfferIds.includes(id)))
        ];
        const mainOfferIds = mainOffers.map((offer) => offer.id);
        const additionalOffers = offersWithoutPriceFilter
            .filter((offer) => !mainOfferIds.includes(offer.id))
            .map((offer) => ({...offer, has_required_prices: false}));
        return {
            mainOffersCount: mainOffersWithPriceCount,
            mainOffers,
            additionalOffers
        };
    } else {
        return {
            mainOffersCount: allOffers.length,
            mainOffers: offersOnPage,
            additionalOffers: []
        };
    }
};
import {isEmpty} from "@pg-mono/nodash";

import {SearchFormValuesType} from "../../../search/types/SearchFormValuesType";
import {IOfferListOffer} from "../../types/IOfferListOffer";
import {IOfferListLatestQuery} from "../types/IOfferListLatestQuery";
import {hasPriceFilter} from "../utils/has_price_filter";
import {useFetchAdditionalOfferList} from "./use_fetch_additional_offers_list";

interface IProps {
    offersOnPage: IOfferListOffer[];
    allOffers: IOfferListOffer[];
    latestQuery: IOfferListLatestQuery;
    searchFormValues: SearchFormValuesType;
    privilegedOffers: IOfferListOffer[];
    isLastPage: boolean;
}

export const useGetOfferListingAllOffers = (props: IProps) => {
    const {offersOnPage, allOffers, privilegedOffers, isLastPage, latestQuery, searchFormValues} = props;
    const offersWithoutPriceFilter = useFetchAdditionalOfferList({latestQuery, isLastPage});

    if (hasPriceFilter(searchFormValues)) {
        const mainOffersWithPrice = offersOnPage.filter((offer) => offer.has_required_prices === true);
        const mainOffersWithPriceCount = allOffers.filter((offer) => offer.has_required_prices === true).length;
        const privilegedOfferIds = privilegedOffers.map(({id}) => id);
        const mainOffers = [
            ...privilegedOffers,
            ...(isEmpty(privilegedOffers) ? mainOffersWithPrice : mainOffersWithPrice.filter(({id}) => !privilegedOfferIds.includes(id)))
        ];
        const mainOfferIds = mainOffers.map((offer) => offer.id);
        const additionalOffers = offersWithoutPriceFilter
            .filter((offer) => !mainOfferIds.includes(offer.id))
            .map((offer) => ({...offer, has_required_prices: false}));
        return {
            mainOffersCount: mainOffersWithPriceCount,
            mainOffers,
            additionalOffers
        };
    } else {
        return {
            mainOffersCount: allOffers.length,
            mainOffers: offersOnPage,
            additionalOffers: []
        };
    }
};
